import { render } from "./UsPage.vue?vue&type=template&id=798e6d68&scoped=true"
import script from "./UsPage.vue?vue&type=script&lang=js"
export * from "./UsPage.vue?vue&type=script&lang=js"

import "./UsPage.vue?vue&type=style&index=0&id=798e6d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798e6d68"]])

export default __exports__